import React, { Component } from 'react';
import BaseLayout from './../../templates/base'
import PermissionEditForm from './../../elements/permissions/form';
import PermissionsAdd from './../../elements/permissions/widget/permissions_add';

class PermissionsForm extends Component {
	render() {
		return (
			<PermissionEditForm {...this.props}/>
		)
	}

	componentWillMount() {
		this.props.resetPermissionEdit();
	}
}

//export default BaseLayout(PermissionsForm, {title: `Crear Permiso`, subnav: {icon: 'fa-user-secret', name: 'Administración', actions: {url: '/permisos/crear', name: 'Agregar Permiso'}}});
export default BaseLayout(PermissionsForm, {
	title: 'Crear Permiso',
	subnav: {
		icon: 'fa-user-secret',
		name: 'Administración',
		actions: [
			{
				type: 'element',
				url: null,
				name: 'Agregar',
				element: <PermissionsAdd />
			}
		]
	}
});


// WEBPACK FOOTER //
// ./src/layouts/permissions/create.jsx